import {
	FeatureType,
	HotelStatic,
	HotelStaticDataDto
} from '@wwt/entities/api/search-response'

import { addIdToImages } from './utils/addIdToImages.ts'
import { addTypeToFeatures } from './utils/addTypeToFeatures.ts'
import { refineUrl } from './utils/refineUrl.ts'

export const getHotelStatic = (
	hotelStaticBase: HotelStaticDataDto
): HotelStatic => {
	if (
		hotelStaticBase.includedFeatures === undefined ||
		hotelStaticBase.includedFeatures.length === 0
	) {
		return hotelStaticBase as HotelStatic
	}

	return {
		...hotelStaticBase,
		web: refineUrl(hotelStaticBase.web),
		includedFeatures: addTypeToFeatures(
			hotelStaticBase.includedFeatures,
			FeatureType.included
		),
		images: addIdToImages(hotelStaticBase.images)
	}
}
